import { Message } from '../types';
import { Paper } from '@mantine/core';
import { useMessageContent } from '../hooks/useMessageContent';

export const MessageHtml = ({ record }: { record: Message }) => {
    const { messageHtml } = useMessageContent(record);

    return (
        <Paper p={'lg'} style={{ height: '100%' }}>
            <iframe
                srcDoc={messageHtml}
                style={{
                    width: '100%',
                    height: '100%',
                    minHeight: '500px',
                    border: 'none'
                }}
                sandbox="allow-same-origin"
            />
        </Paper>
    );
};

